<!--
 * @LastEditTime: 2020-04-21 17:51:05
 * @Description: 会话日志
 * @Date: 2019-12-16 16:27:34
 * @Author: @虾哔哔
 -->
<template>
	<div>
		<h3 class="e-main__title">{{ $route.meta.title }}</h3>
		<div class="session-report">

			<div class="header tool-my30">
				<el-input placeholder="输入用户昵称进行搜索" v-model="user_name" @keyup.enter.native="getSessionReport(1)" clearable>
					<i slot="suffix" class="el-input__icon el-icon-search" @click="getSessionReport(1)" style="cursor: pointer;"></i>
				</el-input>
				<!--  -->
				<el-select v-model="channel" placeholder="全部来源" @change="getSessionReport(1)">
					<el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in channelList"></el-option>
				</el-select>
				<!--  -->
				<el-select v-model="status" placeholder="全部状态" @change="getSessionReport(1)">
					<el-option label="全部状态" :value="2"></el-option>
					<el-option label="未结束" :value="0"></el-option>
					<el-option label="已结束" :value="1"></el-option>
				</el-select>
				<!--  -->
				<el-date-picker :clearable="false" v-model="dataTime" :picker-options="$pickerOptions"   @change="getSessionReport(1)" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				<!--  -->
			</div>
			<!--  -->
			<div class="content tool-my30">
				<el-table :data="tableData" border>
					<el-table-column type="index"></el-table-column>
					<el-table-column prop="user_name" label="用户昵称" show-overflow-tooltip></el-table-column>
					<el-table-column prop="channel" label="会话来源">
						<template slot-scope="scope">
							{{findChannelVal(scope.row.channel)}}
						</template>
					</el-table-column>
					<el-table-column prop="start_time" label="开始时间" width="300"></el-table-column>
					<el-table-column prop="count" label="会话轮次"></el-table-column>
					<el-table-column label="会话状态">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status === 0" type="danger">未结束</el-tag>
							<el-tag v-if="scope.row.status === 1" type="info">已结束</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" @click="openViewContext(scope.row)">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--  -->
			<div class="pagination">
				<el-pagination @current-change="getSessionReport" :current-page="pagination.page" :page-size="pagination.per_page" :total="pagination.total" background layout="total, prev, pager, next"></el-pagination>
			</div>
			<!-- component -->
			<ViewContext ref="ViewContext" />
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import ViewContext from "./components/ViewContext";

	const channelList = [
		{
			value: "all",
			label: "全部来源"
		},
		{
			value: "wsc",
			label: "微商城H5"
		},
		{
			value: "wechat",
			label: "微信公众号"
		},
		{
			value: "mmp",
			label: "微信小程序"
		},
		{
			value: "yzWeapp",
			label: "有赞小程序公共版"
		},
		{
			value: "spotlight",
			label: "有赞精选小程序"
		},
		{
			value: "guang",
			label: "爱逛直播"
		},
		{
			value: "tripartite",
			label: "App开店"
		},
		{
			value: "fx",
			label: "分销"
		},
		{
			value: "wxdkf",
			label: "微小店"
		},
		{
			value: "ebottest",
			label: "测试窗口"
		}
	];
	export default {
		components: {
			ViewContext
		},
		data() {
			return {
				user_name: "",
				channel: "all", // 会话来源
				status: 2,
				dataTime: [
					dayjs()
						.subtract(7, "day")
						.format("YYYY-MM-DD"),
					dayjs().format("YYYY-MM-DD")
				],
				tableData: [],
				channelList: channelList,
				pagination: {
					page: 1, // 当前页
					per_page: 10, // 每页条数
					total: 0 // 总数
				}
			};
		},
		computed: {
			...mapGetters(["shopId"])
		},
		mounted() {
			this.getSessionReport();
		},
		methods: {
			findChannelVal(key) {
				try {
					return channelList.filter(item => {
						return item.value === key;
					})[0].label;
				} catch (error) {}
			},
			// 获取类目
			getSessionReport(page) {
				let params = {
					authority_id: this.shopId,
					page: page || this.pagination.page,
					per_page: this.pagination.per_page,
					user_name: this.user_name,
					channel: this.channel, // 会话来源
					status: this.status,
					start_time: this.dataTime[0],
					end_time: this.dataTime[1]
				};
				this.$store.dispatch("DataLog/getSessionReport", params).then(res => {
					console.log(res);
					if (res.data.code === 2000) {
						this.tableData = res.data.data.list;
						this.pagination.page = res.data.data.page;
						this.pagination.per_page = res.data.data.per_page;
						this.pagination.total = res.data.data.total;
					}
				});
			},
			openViewContext(data) {
				this.$refs.ViewContext.openDialog(data);
			}
		}
	};
</script>

<style lang="less" scoped>
.el-button--text{
  color:#4162FB
}
.session-report {
	background: white;
	padding:15px;
	.header {
		display: grid;
		grid-template-rows: 1fr;
		grid-template-columns: 250px auto auto auto 1fr;
		grid-column-gap: 20px;
	}
	.pagination {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}
</style>